// extracted by mini-css-extract-plugin
module.exports = {"v17xqcv8":"v17xqcv8","search-content-header":"search-content-header","search-news-container":"search-news-container","t1l5an8v":"t1l5an8v","equcllk":"equcllk"};